import { TableProps } from 'antd/es/table';

import { Status } from '@Components/Base';
// width = designs width/design width + 2px(empirical value so it doesn't wrap in case of multiple words)
export const mapColumns: TableProps['columns'] = [
  {
    title: 'TENDER NO.',
    dataIndex: 'tenderNo',
    key: 'id',
    sorter: true,
    ellipsis: false,
    width: 128,
  },
  {
    title: 'MATERIAL GROUP',
    dataIndex: 'materialGroup',
    ellipsis: false,
    width: 149,
  },
  {
    title: 'CLASSIFICATION',
    dataIndex: 'classification',
    sorter: true,
    ellipsis: false,
    width: 132,
  },
  {
    title: 'SENT ON',
    dataIndex: 'sentOn',
    key: 'tenderSentDate',
    sorter: true,
    ellipsis: false,
    width: 135,
  },
  {
    title: 'EXPIRY ON',
    dataIndex: 'expiryOn',
    key: 'tenderExpiryDate',
    sorter: true,
    ellipsis: false,
    width: 135,
  },
  {
    title: 'TENDER FOR',
    dataIndex: 'tenderFor',
    sorter: false,
    ellipsis: false,
    width: 135,
  },
  {
    title: 'PR FOR',
    dataIndex: 'prFor',
    sorter: false,
    ellipsis: false,
    width: 110,
  },
  {
    title: 'TENDER EXTENTION',
    dataIndex: 'tenderExtention',
    sorter: false,
    ellipsis: false,
    width: 155,
  },
  {
    title: 'TENDER MODE',
    dataIndex: 'tenderMode',
    sorter: false,
    ellipsis: false,
    width: 123,
  },
  {
    title: 'PRIORITY',
    dataIndex: 'priority',
    sorter: false,
    ellipsis: false,
    width: 91,
  },
  {
    title: 'SENT COUNT',
    dataIndex: 'sentCount',
    sorter: false,
    ellipsis: false,
    width: 111,
  },
  {
    title: 'REPLY COUNT',
    dataIndex: 'replyCount',
    sorter: false,
    ellipsis: false,
    width: 118,
  },
  {
    title: 'APPROVER RECIEVED ON',
    dataIndex: 'approverRecievedOn',
    sorter: false,
    ellipsis: false,
    width: 187,
  },
  {
    title: 'DELAY DAYS',
    dataIndex: 'delayDays',
    sorter: false,
    ellipsis: false,
    width: 109,
  },
  {
    title: 'TENDER AMOUNT',
    dataIndex: 'tenderAmonunt',
    sorter: false,
    ellipsis: false,
    width: 140,
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'status', // todo specify
    render: (text) => <Status text={text} />,
  },
  {
    title: 'APPROVER',
    dataIndex: 'approver',
    sorter: false,
    ellipsis: false,
    width: 100,
  },
];
